module.exports = __webpack_public_path__ + "fromBrideToFather-we-r.41fda643.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToFather-we-r.jpg
// module id = Cn8f
// module chunks = 0